import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.svg";
import { setSearchQuery } from "../features/filter/filterSlice";

export default function Navbar() {
  const dispatch = useDispatch();

  const handleSearch = (e) => {
    e.preventDefault();
    dispatch(setSearchQuery(e.target.value));
  };
  return (
    <>
      <nav className="container relative py-3">
        <div className="flex items-center justify-between">
          <a href="/">
            <Link to="/">
              <img src={logo} alt="Logo" />
            </Link>
          </a>
          <div className="flex-1 max-w-xs search-field group">
            <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500"></i>
            <input
              type="text"
              placeholder="Search Task"
              className="search-input"
              id="lws-searchTask"
              onChange={handleSearch}
            />
          </div>
        </div>
      </nav>
    </>
  );
}
